import React from "react";
import { Link } from "../components/Router";
import logo from "../img/earnings-call-brand.svg";
import codixel from "../img/codixel.svg";
import Container from "react-bootstrap/Container";
import StoreBadge from "react-store-badge";
import {
  APPLE_APP_STORE_URL,
  GOOGLE_PLAY_STORE_URL,
} from "components/AppStoreUtil";
import "../sass/footer.scss";

const Footer = () => {
  return (
    <>
      <footer className="main-footer">
        <Container>
          <div className="footer-container">
            <div className="first-block">
              <div className="img-container">
                <img src={logo} alt="EarningsCall Logo" />
              </div>
            </div>
            <div className="footer-end-content">
              <div className="list-content">
                <div className="list-title">Company</div>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <Link to="/about" className="footer-link">
                      About Us
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/terms" className="footer-link">
                      Terms of Use
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/privacy" className="footer-link">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="list-content">
                <div className="list-title">Quick Link</div>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <Link to="/calendar" className="footer-link">
                      Calendar
                    </Link>
                  </li>
                  {/* <li className="footer-list-item">
                    <Link to="/chat" className="footer-link">
                      ChatAI
                    </Link>
                  </li> */}
                  <li className="footer-list-item">
                    <Link to="/sp-500-holdings" className="footer-link">
                      S&P 500 Companies
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/top-employers" className="footer-link">
                      Top Employers
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/login" className="footer-link">
                      Login
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="list-content">
                <div className="list-title">Pricing</div>
                <ul className="footer-list">
                  {/* <li className="footer-list-item">
                    <Link to="/chat-ai-pricing" className="footer-link">
                      ChatAI Pricing
                    </Link>
                  </li> */}
                  <li className="footer-list-item">
                    <Link to="/api-pricing" className="footer-link">
                      API Pricing
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="list-content">
                <div className="list-title">Resource</div>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <Link to="/api-guide" className="footer-link">
                      API Resource
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/api-details" className="footer-link">
                      API Details
                    </Link>
                  </li>
                  <li className="footer-list-item">
                    <Link to="/blog" className="footer-link">
                      Blog
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="list-content">
                <p className="list-title">Download</p>
                <StoreBadge
                  name="EarningsCall"
                  googlePlayUrl={GOOGLE_PLAY_STORE_URL}
                  appStoreUrl={APPLE_APP_STORE_URL}
                />
                <div className="design-block">
                  <Link
                    to="https://codixel.tech/"
                    target="_blank"
                    rel="dofollow"
                  >
                    <span className="by">Designed By</span>
                    <img src={codixel} alt="Codixel" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-icon-text-content">
            <div className="desc">
              Unlock critical insights with complete earnings call transcripts
              and analysis, empowering investors and analysts to make faster,
              data-driven decisions that drive smarter investments.
            </div>
            <div className="icon-container">
              <Link to="https://github.com/EarningsCall" className="icon-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1776_50)">
                    <circle cx="16" cy="16" r="16" fill="#4DEC8C" />
                    <path
                      d="M15.9985 4C9.373 4 4 9.50867 4 16.3041C4 21.7393 7.438 26.3503 12.208 27.9787C12.808 28.092 13.027 27.7121 13.027 27.3858C13.027 27.0932 13.0165 26.3196 13.0105 25.2933C9.673 26.0362 8.968 23.6434 8.968 23.6434C8.4235 22.2218 7.636 21.8434 7.636 21.8434C6.5455 21.0806 7.717 21.0959 7.717 21.0959C8.9215 21.1832 9.5545 22.3643 9.5545 22.3643C10.6255 24.2439 12.364 23.7016 13.048 23.3861C13.156 22.591 13.4665 22.0487 13.81 21.7408C11.146 21.4298 8.344 20.3744 8.344 15.6607C8.344 14.3173 8.812 13.2189 9.58 12.358C9.4555 12.047 9.0445 10.7955 9.697 9.10272C9.697 9.10272 10.705 8.77184 12.997 10.3635C13.954 10.0908 14.98 9.95445 16.0015 9.94986C17.02 9.95599 18.0475 10.0908 19.006 10.365C21.2965 8.77337 22.303 9.10425 22.303 9.10425C22.957 10.7985 22.546 12.0485 22.423 12.3595C23.1925 13.2204 23.656 14.3188 23.656 15.6623C23.656 20.3882 20.851 21.4283 18.178 21.7331C18.6085 22.1131 18.9925 22.8637 18.9925 24.0111C18.9925 25.6563 18.9775 26.9829 18.9775 27.3858C18.9775 27.7152 19.1935 28.0981 19.8025 27.9771C24.565 26.3472 28 21.7377 28 16.3041C28 9.50867 22.627 4 15.9985 4Z"
                      fill="#292929"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1776_50">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
              <Link
                to="https://www.facebook.com/profile.php?id=100088689434387"
                className="icon-block"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.17764 0 0 7.17764 0 16C0 24.8217 7.17764 32 16 32C24.8217 32 32 24.8217 32 16C32 7.17764 24.823 0 16 0ZM19.9791 16.5633H17.376V25.8413H13.5187C13.5187 25.8413 13.5187 20.7718 13.5187 16.5633H11.6852V13.2841H13.5187V11.1631C13.5187 9.64408 14.2406 7.27044 17.4114 7.27044L20.2697 7.2814V10.4645C20.2697 10.4645 18.5328 10.4645 18.1951 10.4645C17.8574 10.4645 17.3773 10.6334 17.3773 11.3578V13.2848H20.3161L19.9791 16.5633Z"
                    fill="#4DEC8C"
                  />
                </svg>
              </Link>
              <Link
                to="https://www.instagram.com/earningscallapp/"
                className="icon-block"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1395_417)">
                    <path
                      d="M19.0625 16C19.0625 17.6914 17.6914 19.0625 16 19.0625C14.3086 19.0625 12.9375 17.6914 12.9375 16C12.9375 14.3086 14.3086 12.9375 16 12.9375C17.6914 12.9375 19.0625 14.3086 19.0625 16Z"
                      fill="#4DEC8C"
                    />
                    <path
                      d="M23.1621 10.5813C23.0149 10.1824 22.78 9.82129 22.4749 9.5249C22.1785 9.21973 21.8176 8.98486 21.4185 8.83765C21.0947 8.71191 20.6084 8.56226 19.7126 8.52148C18.7437 8.47729 18.4531 8.46777 16 8.46777C13.5466 8.46777 13.2561 8.47705 12.2874 8.52124C11.3916 8.56226 10.905 8.71191 10.5815 8.83765C10.1824 8.98486 9.82129 9.21973 9.52515 9.5249C9.21997 9.82129 8.98511 10.1821 8.83765 10.5813C8.71191 10.905 8.56226 11.3916 8.52148 12.2874C8.47729 13.2561 8.46777 13.5466 8.46777 16C8.46777 18.4531 8.47729 18.7437 8.52148 19.7126C8.56226 20.6084 8.71191 21.0947 8.83765 21.4185C8.98511 21.8176 9.21973 22.1785 9.5249 22.4749C9.82129 22.78 10.1821 23.0149 10.5813 23.1621C10.905 23.2881 11.3916 23.4377 12.2874 23.4785C13.2561 23.5227 13.5464 23.532 15.9998 23.532C18.4534 23.532 18.7439 23.5227 19.7124 23.4785C20.6082 23.4377 21.0947 23.2881 21.4185 23.1621C22.2197 22.853 22.853 22.2197 23.1621 21.4185C23.2878 21.0947 23.4375 20.6084 23.4785 19.7126C23.5227 18.7437 23.532 18.4531 23.532 16C23.532 13.5466 23.5227 13.2561 23.4785 12.2874C23.4377 11.3916 23.2881 10.905 23.1621 10.5813ZM16 20.7175C13.3943 20.7175 11.282 18.6055 11.282 15.9998C11.282 13.394 13.3943 11.282 16 11.282C18.6055 11.282 20.7178 13.394 20.7178 15.9998C20.7178 18.6055 18.6055 20.7175 16 20.7175ZM20.9043 12.198C20.2954 12.198 19.8018 11.7043 19.8018 11.0955C19.8018 10.4866 20.2954 9.99292 20.9043 9.99292C21.5132 9.99292 22.0068 10.4866 22.0068 11.0955C22.0066 11.7043 21.5132 12.198 20.9043 12.198Z"
                      fill="#4DEC8C"
                    />
                    <path
                      d="M16 0C7.16479 0 0 7.16479 0 16C0 24.8352 7.16479 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16479 24.8352 0 16 0ZM25.1321 19.7878C25.0876 20.7659 24.9321 21.4336 24.7051 22.0181C24.2278 23.2522 23.2522 24.2278 22.0181 24.7051C21.4338 24.9321 20.7659 25.0874 19.7881 25.1321C18.8083 25.1768 18.4954 25.1875 16.0002 25.1875C13.5049 25.1875 13.1921 25.1768 12.2122 25.1321C11.2344 25.0874 10.5664 24.9321 9.98218 24.7051C9.3689 24.4744 8.81372 24.1128 8.35474 23.6453C7.88745 23.1865 7.52588 22.6311 7.29517 22.0181C7.06812 21.4338 6.9126 20.7659 6.86816 19.7881C6.823 18.8081 6.8125 18.4951 6.8125 16C6.8125 13.5049 6.823 13.1919 6.86792 12.2122C6.91235 11.2341 7.06763 10.5664 7.29468 9.98193C7.52539 9.3689 7.88721 8.81348 8.35474 8.35474C8.81348 7.88721 9.3689 7.52563 9.98193 7.29492C10.5664 7.06787 11.2341 6.9126 12.2122 6.86792C13.1919 6.82324 13.5049 6.8125 16 6.8125C18.4951 6.8125 18.8081 6.82324 19.7878 6.86816C20.7659 6.9126 21.4336 7.06787 22.0181 7.29468C22.6311 7.52539 23.1865 7.88721 23.6455 8.35474C24.1128 8.81372 24.4746 9.3689 24.7051 9.98193C24.9324 10.5664 25.0876 11.2341 25.1323 12.2122C25.177 13.1919 25.1875 13.5049 25.1875 16C25.1875 18.4951 25.177 18.8081 25.1321 19.7878Z"
                      fill="#4DEC8C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1395_417">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
              <Link
                to="https://www.linkedin.com/company/earningscall/"
                className="icon-block"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.16479 0 0 7.16479 0 16C0 24.8352 7.16479 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16479 24.8352 0 16 0ZM11.3506 24.1875H7.45386V12.4641H11.3506V24.1875ZM9.40234 10.8633H9.37695C8.06934 10.8633 7.22363 9.96313 7.22363 8.83813C7.22363 7.68774 8.09521 6.8125 9.42822 6.8125C10.7612 6.8125 11.5815 7.68774 11.6069 8.83813C11.6069 9.96313 10.7612 10.8633 9.40234 10.8633ZM25.4014 24.1875H21.5051V17.9158C21.5051 16.3396 20.9409 15.2646 19.531 15.2646C18.4546 15.2646 17.8135 15.9897 17.5317 16.6897C17.4287 16.9402 17.4036 17.2903 17.4036 17.6406V24.1875H13.5071C13.5071 24.1875 13.5581 13.564 13.5071 12.4641H17.4036V14.124C17.9214 13.3252 18.8479 12.189 20.9153 12.189C23.479 12.189 25.4014 13.8645 25.4014 17.4653V24.1875Z"
                    fill="#4DEC8C"
                  />
                </svg>
              </Link>
              <Link
                to="https://twitter.com/EarningsCallApp"
                className="icon-block"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0Z"
                    fill="#4DEC8C"
                  />
                  <path
                    d="M17.7504 14.5522L24.5998 6.59033H22.9767L17.0293 13.5035L12.2792 6.59033H6.80054L13.9836 17.0443L6.80054 25.3936H8.42372L14.7043 18.093L19.7207 25.3936H25.1994L17.75 14.5522H17.7504ZM9.00856 7.81225H11.5017L22.9774 24.2272H20.4843L9.00856 7.81225Z"
                    fill="#292929"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="bottom-content">
            <div className="copy-right-text">
              &copy;EarningsCall, LLC {new Date().getFullYear()}
            </div>
          </div>

          {/* {isAdminUser && <AdminDebugInfo />} */}
        </Container>
      </footer>
    </>
  );
};

export default Footer;
